import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetofivejyotilingadarshancabs() {



const cardData =
{
  keyword: 'Pune to 5 Jyotirlinga Darshan Cab',

  heading: 'Lotus Cab: Pune to 5 Jyotirlinga Darshan Cab',

headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to 5 Jyotirlinga Darshan Cab services for devotees seeking a comfortable and spiritually enriching pilgrimage across Maharashtra. Whether you are planning a family pilgrimage, senior citizen yatra, group tour, or customized temple circuit, we provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus vehicles driven by experienced chauffeurs familiar with all major Jyotirlinga routes. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, flexible travel itineraries, and safe long-distance journeys, Lotus Cabs ensures a peaceful, convenient, and memorable 5 Jyotirlinga Darshan experience.",

  top: 'Top Jyotirlinga Temples to Visit with Lotus Cab',

topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar Jyotirlinga, located in the Sahyadri Hills near Pune, is one of the twelve sacred Jyotirlingas of Lord Shiva and marks the beginning of many Maharashtra pilgrimage circuits. Surrounded by dense forests and picturesque landscapes, the temple offers a peaceful spiritual atmosphere where devotees perform darshan, Rudrabhishek, and other sacred rituals throughout the year."
    },
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Trimbakeshwar Jyotirlinga, situated near Nashik at the foothills of Brahmagiri Hills, is one of India's most revered Shiva temples. The temple is famous for its unique three-faced Jyotirlinga, sacred Kushavarta Kund, and religious ceremonies such as Narayan Nagbali and Kalsarp Dosh Puja. Thousands of pilgrims visit this holy shrine every year seeking divine blessings."
    },
    {
        title: "Grishneshwar Jyotirlinga",
        description:
            "Grishneshwar Jyotirlinga, located near the UNESCO World Heritage Site of Ellora Caves in Chhatrapati Sambhajinagar (Aurangabad), is the twelfth and final Jyotirlinga. The beautifully carved temple showcases magnificent Hemadpanti architecture and offers devotees a deeply spiritual experience while also allowing them to explore the nearby historical monuments."
    },
    {
        title: "Aundha Nagnath Jyotirlinga",
        description:
            "Aundha Nagnath Jyotirlinga in Hingoli district is believed by many devotees to be one of the oldest Jyotirlinga temples in India. Renowned for its ancient architecture, spiritual significance, and peaceful surroundings, the temple attracts pilgrims from across the country who come to seek Lord Shiva's blessings and experience its rich religious heritage."
    },
    {
        title: "Parli Vaijnath Jyotirlinga",
        description:
            "Parli Vaijnath Jyotirlinga in Beed district is one of Maharashtra's most important Shiva temples and completes the revered 5 Jyotirlinga Darshan circuit. The temple is famous for its beautiful architecture, sacred rituals, and spiritual atmosphere, drawing thousands of devotees throughout the year for darshan, religious ceremonies, and family pilgrimages."
    },
    {
        title: "Ellora Caves",
        description:
            "Located close to Grishneshwar Jyotirlinga, the UNESCO-listed Ellora Caves are among India's greatest archaeological treasures. The rock-cut caves feature magnificent Hindu, Buddhist, and Jain monuments, including the world-famous Kailasa Temple, making this destination a perfect combination of spirituality, history, and architectural excellence."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Shani Shingnapur is a renowned pilgrimage destination dedicated to Lord Shani and is frequently included in the 5 Jyotirlinga Darshan itinerary. The village is famous for its unique tradition of homes without doors and its powerful spiritual significance, attracting devotees seeking protection, prosperity, and relief from planetary influences."
    },
    {
        title: "Nashik Panchavati",
        description:
            "Panchavati in Nashik is an important religious destination closely associated with the Ramayana. Pilgrims visiting Trimbakeshwar often explore Panchavati to visit Kalaram Temple, Sita Gufa, Ram Kund, and the sacred Godavari Ghats, adding greater spiritual value to their pilgrimage."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Situated in Chhatrapati Sambhajinagar, Bibi Ka Maqbara is one of Maharashtra's most iconic Mughal monuments. Pilgrims visiting Grishneshwar and Ellora frequently include this historical attraction in their journey to experience its impressive architecture and rich cultural heritage."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is one of India's finest medieval hill forts and lies close to Grishneshwar Jyotirlinga and Ellora Caves. Known for its remarkable military architecture, historic defenses, and panoramic hilltop views, the fort provides travelers with an enriching historical experience alongside their sacred pilgrimage."
    }
],

  "services": [
    {
      "name": "Pune to 5 Jyotirlinga Darshan Cab",
      "description": "Book Pune to 5 Jyotirlinga Darshan cab for a complete Panch Jyotirlinga pilgrimage tour covering Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. The service is available for 3 to 5 days depending on travel preference and darshan schedule. Vehicles include AC sedan, SUV, and premium MPV categories suitable for families and senior citizens. Drivers are experienced with temple routes, rural highways, and spiritual circuits across Maharashtra. Transparent per km pricing with clear driver allowance and toll details ensures a hassle-free pilgrimage journey focused on comfort and devotion."
    },
    {
      "name": "Pune to Panch Jyotirlinga Cab Package",
      "description": "Choose a structured Pune to Panch Jyotirlinga cab package designed for organized temple visits with optimized routing. The package allows flexible travel planning, comfortable seating arrangements, and proper rest halts during long-distance travel. Suitable for families, religious groups, and elderly travelers, the package ensures smooth temple-to-temple connectivity. Fare includes clear breakdown of distance, travel days, and optional overnight stay coordination. Reliable highway travel with well-maintained vehicles ensures a safe and peaceful spiritual tour."
    },
    {
      "name": "Pune to 5 Jyotirlinga Taxi Booking",
      "description": "Secure Pune to 5 Jyotirlinga taxi booking online with advance confirmation and itinerary customization. Travelers can select preferred vehicle category, travel duration, and pickup location within Pune or PCMC. Ideal for pilgrims seeking organized darshan scheduling without transport stress. Per kilometer pricing model ensures cost clarity before departure. Vehicles are cleaned and serviced for long-distance spiritual journeys."
    },
    {
      "name": "Pune to Panch Jyotirlinga Taxi Fare Per Km",
      "description": "Get transparent Pune to Panch Jyotirlinga taxi fare per km with detailed explanation of base rate, driver allowance, toll charges, and minimum daily usage. Fare varies depending on sedan, SUV, or premium category selection. Suitable for budget as well as luxury pilgrimage travel planning. Clear billing helps families estimate total trip cost in advance. Competitive pricing structure ensures affordability without compromising comfort."
    },
    {
      "name": "Affordable Pune to Panch Jyotirlinga Cab",
      "description": "Affordable Pune to Panch Jyotirlinga cab options available for pilgrims seeking economical spiritual travel. Budget-friendly sedan vehicles provide comfortable seating and AC travel for small families. Round-trip and multi-day rental plans reduce per day cost for longer itineraries. Ideal for devotees planning group darshan with controlled expenses. Reliable service ensures peaceful and safe long-distance journey."
    },
    {
      "name": "Luxury Pune to Panch Jyotirlinga Cab",
      "description": "Luxury Pune to Panch Jyotirlinga cab services available with premium SUV and Innova Crysta options for enhanced comfort. Suitable for senior citizens and families requiring spacious seating and smooth suspension for highway travel. Additional luggage space ensures convenience during multi-day pilgrimage. Premium category ensures relaxed long-distance travel with professional drivers experienced in temple circuits."
    },
    {
      "name": "Pune to Panch Jyotirlinga Itinerary Taxi",
      "description": "Structured Pune to Panch Jyotirlinga itinerary taxi service covering optimized temple sequence for time-efficient darshan. Drivers are familiar with best travel routes, rest stops, and fuel stations across Maharashtra. Flexible travel hours allow early morning temple visits and comfortable overnight halts. Ideal for 3, 4, or 5-day pilgrimage plans. Organized routing minimizes travel fatigue during long journeys."
    },
    {
      "name": "Pune to Panch Jyotirlinga Pilgrimage Cab",
      "description": "Dedicated Pune to Panch Jyotirlinga pilgrimage cab designed specifically for spiritual travelers. Safe driving practices, clean interiors, and disciplined schedule management ensure smooth temple visits. Suitable for family groups, senior devotees, and religious tours throughout the year. Clear fare communication before departure avoids hidden charges. Comfortable travel experience supports uninterrupted devotional focus."
    }
  ],

  "tableData": [
    ["Pune to 5 Jyotirlinga Darshan Cab", "Pune to Panch Jyotirlinga Cab Package"],
    ["Pune to 5 Jyotirlinga Taxi Booking", "Pune to Panch Jyotirlinga Taxi Fare Per Km"],
    ["Affordable Pune to Panch Jyotirlinga Cab", "Luxury Pune to Panch Jyotirlinga Cab"],
    ["Pune to Panch Jyotirlinga Itinerary Taxi", "Pune to Panch Jyotirlinga Pilgrimage Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Complete Panch Jyotirlinga Coverage",
      "WhyChoosedescription": "Covers all five major Jyotirlinga temples in Maharashtra with structured routing and comfortable multi-day travel planning."
    },
    {
      "WhyChooseheading": "Transparent Per Kilometer Pricing",
      "WhyChoosedescription": "Clear fare structure including driver allowance, toll charges, and daily travel distance ensures budget transparency."
    },
    {
      "WhyChooseheading": "Experienced Highway Drivers",
      "WhyChoosedescription": "Professional drivers familiar with rural roads, temple access routes, and long-distance highway safety."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Choose sedan, SUV, or premium MPV categories depending on group size and comfort requirements."
    },
    {
      "WhyChooseheading": "Customizable 3–5 Day Itinerary",
      "WhyChoosedescription": "Flexible travel duration allowing devotees to complete darshan comfortably without rush."
    },
    {
      "WhyChooseheading": "Senior Citizen Friendly Travel",
      "WhyChoosedescription": "Spacious seating and smooth ride quality ideal for elderly devotees and family pilgrims."
    },
    {
      "WhyChooseheading": "Safe & Well-Maintained Vehicles",
      "WhyChoosedescription": "Regularly serviced vehicles ensuring reliability during long spiritual journeys."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance",
      "WhyChoosedescription": "Round-the-clock support for itinerary planning, fare queries, and booking confirmation."
    }
  ]
}




const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to 5 Jyotirlinga Darshan cab service?',
    answer: 'Yes, Lotus Cab offers dedicated Pune to 5 Jyotirlinga Darshan cab packages covering major Jyotirlingas in Maharashtra including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath.',
  },
  {
    question: 'Which 5 Jyotirlingas are covered in the Pune darshan package?',
    answer: 'Our Pune to 5 Jyotirlinga Darshan cab package typically covers Bhimashankar, Trimbakeshwar (Nashik), Grishneshwar (near Ellora), Aundha Nagnath (Hingoli), and Parli Vaijnath (Beed district).',
  },
  {
    question: 'How many days are required for Pune to 5 Jyotirlinga tour?',
    answer: 'The complete 5 Jyotirlinga Darshan from Pune usually requires 3 to 4 days depending on travel pace, temple timings, and halts.',
  },
  {
    question: 'What are the charges for Pune to 5 Jyotirlinga Darshan cab?',
    answer: 'Cab charges depend on total distance, number of travel days, and vehicle type such as Sedan or SUV. Lotus Cab provides transparent package pricing with no hidden costs.',
  },
  {
    question: 'Which vehicles are suitable for 5 Jyotirlinga Darshan trip?',
    answer: 'We provide comfortable Sedan cars for small families and spacious SUVs like Ertiga and Innova Crysta for larger groups to ensure smooth long-distance pilgrimage travel.',
  },
  {
    question: 'Is this cab package suitable for senior citizens?',
    answer: 'Yes, Lotus Cab ensures comfortable vehicles, experienced drivers, and flexible halts, making the 5 Jyotirlinga Darshan trip suitable for senior citizens and family groups.',
  },
  {
    question: 'Are toll, driver allowance, and parking included in the package?',
    answer: 'Package details are shared clearly during booking. Toll, parking, and driver allowance are either included in the package or billed transparently as per agreement.',
  },
  {
    question: 'Can I customize the Pune to 5 Jyotirlinga Darshan itinerary?',
    answer: 'Yes, Lotus Cab allows itinerary customization based on your preferred route, stay duration, temple visit sequence, and accommodation plans.',
  },
  {
    question: 'Is advance booking recommended for Jyotirlinga Darshan?',
    answer: 'Advance booking is highly recommended, especially during Shravan month, Mahashivratri, and festive seasons due to high travel demand.',
  },
  {
    question: 'How can I book Pune to 5 Jyotirlinga Darshan cab?',
    answer: 'You can contact Lotus Cab with your travel dates, number of passengers, and vehicle preference to receive a detailed itinerary and confirmed booking instantly.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Shinde',
    feedback: 'We booked Lotus Cab for Pune to 5 Jyotirlinga Darshan. The driver was very cooperative, and the journey was smooth across all temples. Highly satisfied with the service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Vaishali Patil',
    feedback: 'Excellent pilgrimage experience with Lotus Cab. Clean Innova, transparent pricing, and proper planning for all five Jyotirlingas. Truly stress-free travel.',
    rating: 5,
  },
];






































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to 5 Jyotirlinga Darshan Cab",
"image": "https://lotuscab.com/assets/images/pune-to-5-jyotirlinga-darshan-cab.jpg",
"description": "Book Pune to 5 Jyotirlinga Darshan Cab with Lotus Cab for a safe, comfortable, and affordable pilgrimage tour. One way, round trip, and customized taxi packages with Sedan, SUV, and AC cabs available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6385"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-5-jyotirlinga-darshan-cab"
}
};









  return (
    <div>
      

<Helmet>
  <title>Pune to 5 Jyotirlinga Darshan Cab | Taxi Package | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to 5 Jyotirlinga Darshan Cab with Lotus Cab at affordable prices. Comfortable Sedan, SUV, and AC taxi packages for Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath with experienced drivers."
/>

<meta
 name="keywords"
 content="Pune to 5 Jyotirlinga Darshan Cab, Pune 5 Jyotirlinga Tour Package, Pune to Jyotirlinga Cab, 5 Jyotirlinga Taxi Package from Pune, Pune to Bhimashankar Cab, Pune to Trimbakeshwar Cab, Pune to Grishneshwar Cab, Pune to Aundha Nagnath Cab, Pune to Parli Vaijnath Cab, Maharashtra 5 Jyotirlinga Cab, One Way Jyotirlinga Cab Pune, Round Trip Jyotirlinga Taxi Pune, Pilgrimage Cab Pune, Affordable Jyotirlinga Cab Pune, Best 5 Jyotirlinga Cab Service, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetofivejyotilingadarshancabs;